import { compose } from '@reduxjs/toolkit';
import { fetchModuleNavigationReducer } from './fetch-module-navigationt';

export const extraReducers = compose(fetchModuleNavigationReducer);

export { fetchModuleNavigation } from './fetch-module-navigationt';
